var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55556 3.63892C7.55556 3.08663 7.10528 2.63111 6.55941 2.71504C5.61684 2.85995 4.71307 3.20946 3.91348 3.74373C2.83543 4.46406 1.99519 5.4879 1.49901 6.68577C1.00284 7.88364 0.873016 9.20174 1.12596 10.4734C1.37891 11.7451 2.00327 12.9131 2.92008 13.83C3.83689 14.7468 5.00498 15.3711 6.27663 15.6241C7.54828 15.877 8.86639 15.7472 10.0643 15.251C11.2621 14.7548 12.286 13.9146 13.0063 12.8365C13.5406 12.037 13.8901 11.1332 14.035 10.1906C14.1189 9.64475 13.6634 9.19447 13.1111 9.19447H9.05556C8.22713 9.19447 7.55556 8.5229 7.55556 7.69447V3.63892Z",
    fill: "#BAEAC8",
    stroke: "#BAEAC8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0139 2C10.0139 1.44771 10.4649 0.991152 11.0088 1.08695C11.4195 1.15927 11.822 1.27632 12.209 1.43664C12.9049 1.7249 13.5373 2.14742 14.0699 2.68007C14.6026 3.21272 15.0251 3.84506 15.3134 4.541C15.4737 4.92804 15.5907 5.33054 15.6631 5.74116C15.7588 6.28508 15.3023 6.73611 14.75 6.73611L10.2139 6.73611C10.1034 6.73611 10.0139 6.64657 10.0139 6.53611V2Z",
    fill: "#BAEAC8",
    stroke: "#BAEAC8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.947bd56cd2d73ffc7635176b53a5a021.svg";
export { ForwardRef as ReactComponent };